<template>
    <tr :class="[{'clickable': $_loggedUser_action_allowed('advertisingBanners', 'read')}]" @click.stop="showAdvertisingBannerDetail(advertisingBanner.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="'abCheckbox'+advertisingBanner.id"
                 :value="advertisingBanner.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="'abCheckbox'+advertisingBanner.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td data-th="Název" class="first_data"><strong>{{ advertisingBanner.name }}</strong></td>
        <td :data-th="'Zařízení' | translate">
           <span class="dotted" @click.stop="$refs.channelsmodalref.showModal(true)">
                {{ advertisingBanner.recipients_devices_read }} / {{ advertisingBanner.recipients_devices_total}}
              <modal ref="channelsmodalref">
                <div slot="title"><translate>Seznam zařízení odběratele oznámení</translate> ({{ advertisingBanner.recipients_devices_total}})</div>
                <div slot="body">
                  <RecipientDeviceList
                      :id-advertising-banner="advertisingBanner.id"
                      :idSubscriber="idSubscriber"
                  />
                </div>
              </modal>
            </span></td>
        <td :data-th="'Označeno za smazané' | translate" v-html="$_date_formatFull(advertisingBanner.timestamp_deleted)"></td>
        <td data-th="Datum odeslání" class="last_data" v-html="$_date_formatFull(advertisingBanner.showAt)" />
        <td class="no_padding edit">
            <div class="edit_inner">
                <a v-if="isDeletable" class="btn btn_action btn_delete" @click.stop="onDeleteAdvertisingBanner()" :title="$gettext('Smazat')">{{ $gettext('Smazat') }}</a>
            </div>
        </td>
    </tr>
</template>

<script>
import RecipientDeviceList from "../../advertisingBanner/Detail/RecipientDeviceList.vue";
import links from "../../../mixins/links";

export default {
  name: "AdvertisingBannerRow",
  mixins: [links],
  components: {RecipientDeviceList},
    props: {
        advertisingBanner: Object,
        advertisingBannerTypes: Object,
        selectedEntities: Array,
        isDeletable: Boolean,
        idSubscriber: Number,
    },
    methods: {
        onChange: function (e) {
          this.$emit('input', e)
        },
        onDeleteAdvertisingBanner() {
            this.$emit('deleteAdvertisingBanner', this.advertisingBanner.id);
        },
    },
    computed: {
      isChecked() {
        return this.selectedEntities.indexOf(String(this.advertisingBanner.id)) > -1
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/advertisingBanners/AdvertisingBannerRow.vue